import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const ExamComparisonChart = ({ currentExam, recentExams }) => {
  // Get subject keys based on exam type
  const getSubjects = (examType) => {
    if (examType === 'TYT') {
      return [
        { key: 'turkish', label: 'Türkçe', color: 'rgba(59, 130, 246, 0.8)' },
        { key: 'math', label: 'Matematik', color: 'rgba(16, 185, 129, 0.8)' },
        { key: 'science', label: 'Fen', color: 'rgba(139, 92, 246, 0.8)' },
        { key: 'social', label: 'Sosyal', color: 'rgba(249, 115, 22, 0.8)' }
      ];
    }
    return [
      { key: 'mathAyt', label: 'Matematik', color: 'rgba(16, 185, 129, 0.8)' },
      { key: 'physics', label: 'Fizik', color: 'rgba(59, 130, 246, 0.8)' },
      { key: 'chemistry', label: 'Kimya', color: 'rgba(139, 92, 246, 0.8)' },
      { key: 'biology', label: 'Biyoloji', color: 'rgba(236, 72, 153, 0.8)' }
    ];
  };

  const subjects = getSubjects(currentExam.examType);

  // Calculate average nets from recent exams
  const calculateAverages = () => {
    const sameTypeExams = recentExams.filter(e => e.examType === currentExam.examType);
    
    if (sameTypeExams.length === 0) return null;

    const averages = {};
    subjects.forEach(subject => {
      const total = sameTypeExams.reduce((sum, exam) => {
        return sum + (exam.nets[subject.key] || 0);
      }, 0);
      averages[subject.key] = total / sameTypeExams.length;
    });
    
    return averages;
  };

  const averages = calculateAverages();

  const data = {
    labels: subjects.map(s => s.label),
    datasets: [
      {
        label: 'Bu Deneme',
        data: subjects.map(s => currentExam.nets[s.key] || 0),
        backgroundColor: 'rgba(59, 130, 246, 0.8)',
        borderColor: 'rgb(59, 130, 246)',
        borderWidth: 2,
        borderRadius: 6,
      },
      ...(averages ? [{
        label: 'Ortalama',
        data: subjects.map(s => averages[s.key] || 0),
        backgroundColor: 'rgba(156, 163, 175, 0.5)',
        borderColor: 'rgb(156, 163, 175)',
        borderWidth: 2,
        borderRadius: 6,
      }] : [])
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          padding: 15,
          font: {
            size: 12,
            weight: '500'
          }
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleColor: '#fff',
        bodyColor: '#fff',
        borderWidth: 1,
        callbacks: {
          label: function(context) {
            return `${context.dataset.label}: ${context.parsed.y.toFixed(2)} net`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.05)',
        },
        ticks: {
          font: {
            size: 11
          }
        }
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 11
          }
        }
      }
    }
  };

  if (!averages) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        <p>Karşılaştırma için yeterli deneme bulunmuyor</p>
      </div>
    );
  }

  return (
    <div className="h-64">
      <Bar data={data} options={options} />
    </div>
  );
};

export default ExamComparisonChart;
